import axios from 'axios';
import { logOutIfTokenExpired, resultInfo } from 'Components/helpers';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import BaseApi from 'shared/api';
import Swal from 'sweetalert2';

type AddToFavoriteDto = {
   selectedFolderId?: number;
   from_cv_database?: number | null;
   type: 'simple' | 'cv';
};

export function useAddToFavorite(
   payload: AddToFavoriteDto,
   {
      candidateId,
      cvId,
   }: {
      candidateId: number;
      cvId: number;
   },
   {
      token,
      apiKey,
      onSuccess,
      onError,
   }: {
      token: string;
      apiKey: string;
      onError?: () => void;
      onSuccess?: () => void;
   }
) {
   const { t } = useTranslation('global');
   const navigate = useNavigate();

   const onAddFavorite = async () => {
      try {
         const response = await axios.post(
            BaseApi + `/candidates/addtoFavorite/${candidateId}/${cvId}`,
            payload,
            {
               headers: {
                  key: apiKey,
                  token: token,
                  contentType: 'application/json',
               },
            }
         );

         if (response.data.status === 200) {
            resultInfo(
               'success',
               t('employerFavouriteListProfile.addFavSuccessTitle'),
               t('employerFavouriteListProfile.close')
            );

            onSuccess?.();
         } else if (response.data.status === 400) {
            navigate('/');

            Cookies.remove('fname');
            Cookies.remove('user_id');
            Cookies.remove('user_type');
            Cookies.remove('tokenClient');

            resultInfo('warning', response.data.message, t('employerFavouriteListProfile.close'));
         } else {
            Swal.fire({
               icon: 'error',
               text: response.data.message,
               title: t('employerFavouriteListProfile.addFavFailedTitle'),
               confirmButtonText: t('employerFavouriteListProfile.close'),
            });
         }
      } catch (error: any) {
         if (
            error.message === 'Network Error' ||
            error.response.data.message === 'Token has expired'
         ) {
            navigate('/');

            logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
         }

         Swal.fire({
            icon: 'error',
            text: t('employerFavouriteListProfile.addFavFailedTxt'),
            confirmButtonText: t('employerFavouriteListProfile.close'),
            title: t('employerFavouriteListProfile.addFavFailedTitle'),
         });
      }
   };

   return { onAddFavorite };
}
